define('modules/editor/behaviours/has_groupbox',['require','exports','module','../models/editorstate','../views/controls/groupbox'],function(require, exports, module){
  "use strict";
  var EditorState = require("../models/editorstate"),
      GroupState = EditorState.groupState,
      MoveState = EditorState.moveState;
  var GroupBox = require("../views/controls/groupbox");

  module.exports = {
    mixed: function(klass, proto){
      proto.initialize = _.wrap(proto.initialize || _.identity, function(init){
        init.apply(this, _.rest(arguments));
        this.groupBox = null;
        this.listenTo(EditorState, EditorState.GROUP_CHANGE, _.debounce(this._displayGroupBox, 25));
        this.listenTo(GroupState, "change", this._updateGroupBox);
      });
      proto.onRender = _.wrap(proto.onRender || _.identity, this._onGroupBoxRender);
      proto.onRemove = _.wrap(proto.onRemove || _.identity, this._onGroupBoxRemove);
    },
    _onGroupBoxRender: function(onRender){
      this._removeGroupBox();
      this._createGroupBox();
      onRender.apply(this);
    },
    _onGroupBoxRemove: function(onRemove){
      this._removeGroupBox();
      GroupState.clear();
      onRemove.apply(this);
    },
    _displayGroupBox: function(groupState, groupItems){
      this._createGroupBox();
      if(groupItems.length <= 1){
        this._toggleGroupBox(false);
        return;
      }
      var groupAttrs = groupState.toJSON();
      this.groupBox.top.setPosition(groupAttrs.top, groupAttrs.left, groupAttrs.right - groupAttrs.left);
      this.groupBox.bottom.setPosition(groupAttrs.bottom, groupAttrs.left, groupAttrs.right-groupAttrs.left);
      this.groupBox.left.setPosition(groupAttrs.top, groupAttrs.left, groupAttrs.bottom - groupAttrs.top);
      this.groupBox.right.setPosition(groupAttrs.top, groupAttrs.right, groupAttrs.bottom - groupAttrs.top);
      this._toggleGroupBox(true);
    },
    _toggleGroupBox: function(isVisible){
      _.each(this.groupBox, function(bar){
        bar.$el.toggle(isVisible);
      });
    },
    _createGroupBox: function(){
      if(this.groupBox) return;
      this.groupBox = {
        top: new GroupBox.horizontalBar(),
        bottom: new GroupBox.horizontalBar(),
        left: new GroupBox.verticalBar(),
        right: new GroupBox.verticalBar()
      };
      _.each(this.groupBox, function(bar){
        this.$el.prepend(bar.render().$el);
      }, this);
    },
    _removeGroupBox: function(){
      if(!this.groupBox) return;
      _.each(this.groupBox, function(view){
        view.remove();
      });
      this.groupBox = null;
    },
    _updateGroupBox: function(){
      var groupAttrs = GroupState.toJSON();
      this.groupBox.top.setPosition(groupAttrs.top, groupAttrs.left, groupAttrs.right - groupAttrs.left);
      this.groupBox.bottom.setPosition(groupAttrs.bottom, groupAttrs.left, groupAttrs.right-groupAttrs.left);
      this.groupBox.left.setPosition(groupAttrs.top, groupAttrs.left, groupAttrs.bottom - groupAttrs.top);
      this.groupBox.right.setPosition(groupAttrs.top, groupAttrs.right, groupAttrs.bottom - groupAttrs.top);
    }
  };
});

